export default __webpack_public_path__ + "static/SectionTwo_02_02-af5f2e554f785f28310f26415f5bd2e7.png";